import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import giftClient, { GenerateGreetPayload } from '../../../../api/gift';

const useGenerateGreetMutation = (
  options?: UseMutationOptions<string, Error, GenerateGreetPayload>,
) => {
  return useMutation({
    mutationFn: (payload: GenerateGreetPayload) =>
      giftClient.generateGreet(payload),
    ...options,
  });
};

export default useGenerateGreetMutation;
